import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import {
  IIndirectTaxFilingV2Contribution,
  IIndirectTaxFilingV2ContributionsParams,
  IIndirectTaxFilingV2ContributionsResponse,
} from './types';

const EMPTY_CONTRIBUTIONS: IIndirectTaxFilingV2Contribution[] = [];

export function useIndirectTaxFilingV2Contributions(
  filingId: string | null | undefined,
  params: IIndirectTaxFilingV2ContributionsParams | null
) {
  const key =
    filingId && params
      ? `new-sales-tax/filings-v2/${filingId}/contributions?corporationId=${params.corporationId}`
      : null;

  const { data, error, isLoading, mutate } =
    useSWR<IIndirectTaxFilingV2ContributionsResponse>(
      key,
      SWRFetcher({ method: 'GET' })
    );

  return {
    contributions: data?.contributions ?? EMPTY_CONTRIBUTIONS,
    count: data?.count ?? 0,
    isLoading,
    error,
    mutate,
  };
}
